import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';

@Component({
  selector: 'app-chat-carousel',
  templateUrl: './chat-carousel.component.html',
  styleUrl: './chat-carousel.component.scss',
})
export class ChatCarouselComponent extends BaseComponent {
  @Input() items: CarouselItem[] = [];
  @Input() isLoading = true;
  @Output() questionSelected = new EventEmitter<string>();
  currIndex = 0;
  currItem: CarouselItem;
  indicatorsArr: number[] = [];
  visibleQuestions: string[] = [];
  NUM_QUESTIONS_PER_PAGE = 4;

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (!this.currItem) this.currItem = this.items[0];
    this.updateVisibleQuestions();
  }

  ngOnChanges() {
    if (!this.currItem) this.currItem = this.items[0];
    this.updateVisibleQuestions();
  }

  updateVisibleQuestions() {    
    if (!this.currItem || !this.currItem?.questions) return;

    const topicTotalQuestions = this.currItem?.questions.length;
    const startIndex =(this.currIndex * this.NUM_QUESTIONS_PER_PAGE) % topicTotalQuestions;

    this.visibleQuestions = this.wrapQuestions(
      this.currItem?.questions.slice(startIndex),
      this.NUM_QUESTIONS_PER_PAGE
    );

    // Create indicators
    this.indicatorsArr = Array(this.getTotalPages()).fill(0).map((_, i) => i);
  }

  selectTopic(topicId: string) {
    this.currIndex = 0;
    this.currItem =
      this.items.find((item) => item.id === topicId) || this.items[0];
    this.visibleQuestions = [];
    this.updateVisibleQuestions();
  }

  selectQuestion(question: string) {
    // console.log(`CV selectQuestion question is ${question}`);
    if (this.isLoading || !question) return;
    this.questionSelected.emit(question);
  }

  getTotalPages() {
    return Math.ceil(
      this.currItem?.questions.length / this.NUM_QUESTIONS_PER_PAGE
    );
  }

  updateIndex(change: number) {
    const totalPages = this.getTotalPages();
    this.currIndex = (this.currIndex + change + totalPages) % totalPages;
    this.updateVisibleQuestions();
  }

  nextQuestions() {
    if(this.isLoading) return;
    this.updateIndex(1);
  }

  prevQuestions() {
    if(this.isLoading) return;
    this.updateIndex(-1);
  }

  wrapQuestions(questions: string[], count: number): string[] {
    if (!questions || questions.length === 0) return [];
    if (questions?.length >= count) return questions.slice(0, count);  
    return [...questions, ...this.currItem?.questions.slice(0, count - questions.length)];
  }
}

export interface CarouselItem {
  id: string;
  topic: string;
  questions: string[];
}
